import { render, staticRenderFns } from "./MachineWidget.vue?vue&type=template&id=48bc5260&scoped=true"
import script from "./MachineWidget.vue?vue&type=script&lang=js"
export * from "./MachineWidget.vue?vue&type=script&lang=js"
import style0 from "./MachineWidget.vue?vue&type=style&index=0&id=48bc5260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bc5260",
  null
  
)

export default component.exports